import config from '@mmw/contextual-config';

export const ACCESS_TOKEN_KEY = config.core.authApi.accessTokenKey;
export const REFRESH_TOKEN_KEY = config.core.authApi.refreshTokenKey;
export const DEFAULT_ACCESS_TOKEN_HEADER_NAME = 'X-AUTH-ACCESS-TOKEN';
